import { Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import AppShell from "@/components/layout/AppShell";
import Login from "@/pages/Login";
import Overview from "@/pages/Overview";
import Groups from "@/pages/Groups";
import Channels from "@/pages/Channels";
import GroupDetail from "@/pages/GroupDetail";
import LiveEvents from "@/pages/LiveEvents";
import Analytics from "@/pages/Analytics";
import Alerts from "@/pages/Alerts";
import Settings from "@/pages/Settings";
import InviteLinks from "@/pages/InviteLinks";
import PremiumIntel from "@/pages/PremiumIntel";
import PremiumChannelDetail from "@/pages/PremiumChannelDetail";
import FakeViewsAlerts from "@/pages/FakeViewsAlerts";
import WebApp from "@/pages/WebApp";
import { getToken } from "@/lib/api";

const RequireAuth = ({ children }) => {
    const token = getToken();
    if (!token) return <Navigate to="/login" replace />;
    return children;
};

function App() {
    return (
        <div className="App" dir="rtl">
            <BrowserRouter>
                <Suspense fallback={<div className="p-6 text-sm text-muted-foreground">جاري التحميل…</div>}>
                    <Routes>
                        <Route path="/login" element={<Login />} />
                        <Route path="/webapp" element={<WebApp />} />
                        <Route
                            element={
                                <RequireAuth>
                                    <AppShell />
                                </RequireAuth>
                            }
                        >
                            <Route index element={<Overview />} />
                            <Route path="/groups" element={<Groups />} />
                            <Route path="/groups/:chatId" element={<GroupDetail />} />
                            <Route path="/channels" element={<Channels />} />
                            <Route path="/channels/:chatId" element={<GroupDetail />} />
                            <Route path="/live" element={<LiveEvents />} />
                            <Route path="/analytics" element={<Analytics />} />
                            <Route path="/premium" element={<PremiumIntel />} />
                            <Route path="/premium/:chatId" element={<PremiumChannelDetail />} />
                            <Route path="/views-alerts" element={<FakeViewsAlerts />} />
                            <Route path="/alerts" element={<Alerts />} />
                            <Route path="/settings" element={<Settings />} />
                            <Route path="/invite-links" element={<InviteLinks />} />
                        </Route>
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </Suspense>
            </BrowserRouter>
        </div>
    );
}

export default App;
